
// these properties will be available from anywhere via this.property
export const constants = {
    isTouch: "ontouchstart" in window ? function () {document.body.classList.add("touch"); return true;}() : function () {document.body.classList.add("no-touch"); return false;}(),
    body: document.body,
    mainWrap: document.querySelector("html"),
    _window: window,
    $window: $(window),
    _document: document

};

export const bodyLock = {
    parentElements: $("html, body"),
    mainContainer: $(".main"),
    windowWidth: window.innerWidth,
    scrollTop: 0,

    lockBody: function () {
        if (window.pageYOffset) {
            this.scrollTop = window.pageYOffset;
            this.mainContainer.css({
                top: -(this.scrollTop)
            });
        }
        this.parentElements.css({
            maxHeight: "100vh",
            overflow: "hidden"
        });
    },

    unlockBody: function () {
        this.parentElements.css({
            maxHeight: "",
            overflow: ""
        });
        this.mainContainer.css({
            top: ""
        });
        window.scrollTo(0, this.scrollTop);
        window.setTimeout(function () {
            bodyLock.scrollTop = null;
        }, 0);
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/module.js